import client from "./requestclient";

const setVendorProfile = {
  vendorProfileStepOne: async (stepOnePayload) => {
    return await client({
      URL_PATH: `setup-vendor-step-one`,
      method: "POST",
      body: stepOnePayload,
    });
  },

  vendorProfileStepTwo: async (stepTwoPayload) => {
    return await client({
      URL_PATH: `setup-vendor-step-two`,
      method: "POST",
      body: stepTwoPayload,
    });
  },

  vendorProfileStepThree: async (stepThreePayload) => {
    return await client({
      URL_PATH: `setup-vendor-step-three`,
      method: "POST",
      body: stepThreePayload,
    });
  },

  vendorWorkUpload: async (vendorWorkUploadPayload) => {
    return await client({
      URL_PATH: `upload-vendor-work-samples`,
      method: "POST",
      body: vendorWorkUploadPayload,
    });
  },

  vendorProfileOverview: async (id) => {
    if (!id) {
      console.error("Error: ID is undefined");
      return;
    }
    return await client({
      URL_PATH: `vendor-profile-by-id/${id}`,
      method: "GET",
    });
  },


//   fetchVendorsReview: async() =>{
//       const token = localStorage.getItem("token");
//      return await client({
//       URL_PATH: `fetch-vendor-reviews`,
//       method: "GET",
//       headers: {
//           Authorization: `Bearer ${token}`,
//         },
//     });
//   },

//   fetchServices: async() => {
//     return await client({
//         URL_PATH: `fetch-services`,
//         method: "GET",
//       });
//   }

    toggleOnlineStatus: async(onlineStatus) =>{
        return await client({
          URL_PATH: `vendor-toggle-online-status`,
          method: "POST",
          body: onlineStatus,
        });

    }
};

export default setVendorProfile;
